import React from 'react';
import TextFieldIcon from '@material-ui/icons/TextFields';
import FilePickerIcon from '@material-ui/icons/AttachFileOutlined';
import FormSectionIcon from '@material-ui/icons/ViewColumnOutlined';
import SelectFieldIcon from '@material-ui/icons/ArrowDropDownCircleOutlined';
import RadioGroupIcon from '@material-ui/icons/RadioButtonCheckedOutlined';
import CheckBoxIcon from '@material-ui/icons/CheckBoxOutlined';
import TermsAndConditionsIcon from '@material-ui/icons/AssignmentOutlined';
import HorizontalLine from '@material-ui/icons/LineStyle';
import { IDB_ATTRIBUTES, QUESTIONS } from '../../../../../components/RxForm/IDB/constants';

export const TYPE_LAYOUT = 'layout';
export const TYPE_CONTROL = 'control';
export const TYPE_RENDERED_CONTROL = 'rendered-control';

export const CONTROL_DATE = 'date';
export const CONTROL_DROPDOWN = 'dropdown';
export const CONTROL_TEXT = 'text';
export const CONTROL_PARAGRAPH = 'paragraph';
export const CONTROL_RADIOS = 'radios';
export const CONTROL_CHECKBOXES = 'checkboxes';
export const CONTROL_FILE = 'file';
export const CONTROL_TERMS = 'terms';
export const CONTROL_EXISTING = 'existing';

export const LAYOUT_SECTION = 'section';
export const LAYOUT_DIVIDER = 'divider';
export const LAYOUT_COLUMN = 'column';

export const FORM_ELEMENTS = {
  [TYPE_LAYOUT]: [
    {
      name: 'Form Section',
      draggableType: TYPE_LAYOUT,
      system_type: LAYOUT_SECTION,
      accept: TYPE_CONTROL,
      icon: <FormSectionIcon />
    },
    {
      name: 'Section Break',
      draggableType: TYPE_LAYOUT,
      system_type: LAYOUT_DIVIDER,
      icon: <HorizontalLine />
    }
  ],

  [TYPE_CONTROL]: [
    {
      name: 'Text',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_TEXT,
      icon: <TextFieldIcon />
    },
    {
      name: 'Paragraph',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_PARAGRAPH,
      icon: <TextFieldIcon />
    },
    {
      name: 'Dropdown',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_DROPDOWN,
      icon: <SelectFieldIcon />
    },

    {
      name: 'Mult. Choice',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_RADIOS,
      icon: <RadioGroupIcon />
    },

    {
      name: 'Checkboxes',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_CHECKBOXES,
      icon: <CheckBoxIcon />
    },
    {
      name: 'File Upload',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_FILE,
      icon: <FilePickerIcon />
    },
    {
      name: 'Terms',
      draggableType: TYPE_CONTROL,
      system_type: CONTROL_TERMS,
      icon: <TermsAndConditionsIcon />
    }
  ]
};

export const TYPES_WITH_OPTIONS = [CONTROL_DROPDOWN, CONTROL_RADIOS, CONTROL_CHECKBOXES];

export const EDIT_MODE_FORM_BUILDER = 'formbuilder';
export const EDIT_MODE_ORDERINGS = 'orderings';

export const EVENT_ADD_COLUMN = 'add-column';
export const EVENT_DELETE_COLUMN = 'delete-column';
export const EVENT_DELETE_LAYOUT_ELEMENT = 'delete-layout-element';
export const EVENT_ADD_LAYOUT_ELEMENT = 'add-layout-element';
export const EVENT_ADD_CONTROL = 'add-control';
export const EVENT_DELETE_CONTROL = 'delete-control';
export const EVENT_UPDATE_CONTROL = 'update-control';
export const EVENT_MOVE_CONTROL = 'move-control';
export const EVENT_MOVE_LAYOUT = 'move-layout';

export const EXISTING_RX_FIELDS = {
  [IDB_ATTRIBUTES.FIRST_NAME]: QUESTIONS[IDB_ATTRIBUTES.FIRST_NAME],
  [IDB_ATTRIBUTES.LAST_NAME]: QUESTIONS[IDB_ATTRIBUTES.LAST_NAME],
  [IDB_ATTRIBUTES.CASE_NUMBER_TEXT]: QUESTIONS[IDB_ATTRIBUTES.CASE_NUMBER_TEXT],
  [IDB_ATTRIBUTES.INTRAORAL_SCAN_DATE]: QUESTIONS[IDB_ATTRIBUTES.INTRAORAL_SCAN_DATE],
  [IDB_ATTRIBUTES.DOCTOR]: QUESTIONS[IDB_ATTRIBUTES.DOCTOR],
  [IDB_ATTRIBUTES.TREATMENT_LOCATION]: QUESTIONS[IDB_ATTRIBUTES.TREATMENT_LOCATION],
  [IDB_ATTRIBUTES.INITIAL_CASE_SETUP_ASSIGNMENT]: QUESTIONS[IDB_ATTRIBUTES.INITIAL_CASE_SETUP_ASSIGNMENT],
  [IDB_ATTRIBUTES.RUSH_CASE]: QUESTIONS[IDB_ATTRIBUTES.RUSH_CASE],
  [IDB_ATTRIBUTES.CUSTOM_SETUP]: QUESTIONS[IDB_ATTRIBUTES.CUSTOM_SETUP],
  [IDB_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: QUESTIONS[IDB_ATTRIBUTES.SCAN_SUBMISSION_METHOD],
  [IDB_ATTRIBUTES.INTRAORAL_PHOTOS]: QUESTIONS[IDB_ATTRIBUTES.INTRAORAL_PHOTOS],
  [IDB_ATTRIBUTES.ARCH_TYPE]: QUESTIONS[IDB_ATTRIBUTES.ARCH_TYPE],
  [IDB_ATTRIBUTES.TEETH]: QUESTIONS[IDB_ATTRIBUTES.TEETH],
  [IDB_ATTRIBUTES.EXPORT_TYPE]: QUESTIONS[IDB_ATTRIBUTES.EXPORT_TYPE],
  [IDB_ATTRIBUTES.PRINT_ASSIGNMENT]: QUESTIONS[IDB_ATTRIBUTES.PRINT_ASSIGNMENT],
  [IDB_ATTRIBUTES.TRAY_DESIGN_ASSIGNMENT]: QUESTIONS[IDB_ATTRIBUTES.TRAY_DESIGN_ASSIGNMENT],
  [IDB_ATTRIBUTES.INSERT_BRACKETS_ASSIGNMENT]: QUESTIONS[IDB_ATTRIBUTES.INSERT_BRACKETS_ASSIGNMENT],
  [IDB_ATTRIBUTES.BRACKET_LIBRARIES]: QUESTIONS[IDB_ATTRIBUTES.BRACKET_LIBRARIES],
  [IDB_ATTRIBUTES.ARCH_WIRES]: QUESTIONS[IDB_ATTRIBUTES.ARCH_WIRES],
  [IDB_ATTRIBUTES.SHIPPING_LOCATION]: QUESTIONS[IDB_ATTRIBUTES.SHIPPING_LOCATION],
  [IDB_ATTRIBUTES.SHIPPING_METHOD]: QUESTIONS[IDB_ATTRIBUTES.SHIPPING_METHOD],
  [IDB_ATTRIBUTES.ROOT_INTEGRATION_TYPE]: QUESTIONS[IDB_ATTRIBUTES.ROOT_INTEGRATION_TYPE],
  [IDB_ATTRIBUTES.BONDING_DATE]: QUESTIONS[IDB_ATTRIBUTES.BONDING_DATE],
  [IDB_ATTRIBUTES.NOTES]: QUESTIONS[IDB_ATTRIBUTES.NOTES]
};

export const randomId = seed => {
  return `${seed}-${
    Math.random()
      .toString(36)
      .split('.')[1]
  }`;
};

export const fieldHasOptions = systemType => {
  return TYPES_WITH_OPTIONS.includes(systemType);
};
